import { BaseApiRequest } from '@api/BaseApi';

export const getRigDashboardParameters = (signal, selectedRig) => {
  return BaseApiRequest(signal, `/DashboardParameters/Get`, 'gpr', 'POST', {
    rigId: selectedRig.rigId
  });
};

export const updateRigDashboardParameters = (signal, selectedRig, fields) => {
  return BaseApiRequest(signal, `/DashboardParameters/Update`, 'gpr', 'PUT', {
    ...fields,
    rigId: selectedRig.rigId
  });
};

export const getRigFuelPrice = (signal, { selectedRig }) => {
  return BaseApiRequest(signal, `/FuelPrice/Get`, 'gpr', 'POST', {
    rigId: selectedRig.rigId
  });
};

export const updateRigFuelPrice = (signal, selectedRig, fields) => {
  return BaseApiRequest(signal, `/FuelPrice/Update`, 'gpr', 'PUT', {
    ...fields,
    rigId: selectedRig.rigId
  });
};

export const createRigFuelPrice = (signal, selectedRig, fields) => {
  return BaseApiRequest(signal, `/FuelPrice/Create`, 'gpr', 'POST', {
    ...fields,
    rigId: selectedRig.rigId
  });
};

export const deleteFuelPrice = (signal, selectedRig, fields) => {
  return BaseApiRequest(signal, `/FuelPrice/Delete`, 'gpr', 'DELETE', {
    ...fields,
    rigId: selectedRig.rigId
  });
};
